module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero10.png?8899f248";